import { render, staticRenderFns } from "./question-single.vue?vue&type=template&id=0e1094f8&scoped=true&"
import script from "./question-single.vue?vue&type=script&lang=js&"
export * from "./question-single.vue?vue&type=script&lang=js&"
import style0 from "./question-single.vue?vue&type=style&index=0&lang=css&"
import style1 from "./question-single.vue?vue&type=style&index=1&id=0e1094f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1094f8",
  null
  
)

export default component.exports